export default __webpack_public_path__ + "static/media/Inthedark-Lgzn.7ec73c3a.ttf";